import React, { useState, useEffect, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import { fetchLoggedInUser } from "../components/library/LoginUser";
import { Form, Spinner } from "react-bootstrap"
import API_BASE_URL from "../config/api";

export default function Login() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const [notification, setNotification] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.username.trim() || !formData.password.trim()) {
      setNotification({
        type: "error",
        message: "Both username and password are required.",
      });
      return;
    }

    try {
      setIsLoading(true);
      const res = await axios.post(`${API_BASE_URL}/api/auth/login`, {
        username: formData.username,
        password: formData.password,
      });
  
      // Successful login
      login(res.data.token);
      setNotification({ type: "success", message: "Login successful!" });
      // fetchLoggedInUser(formData.username);
      const user = await fetchLoggedInUser(formData.username);
      sessionStorage.setItem("employeeId", user.id);
      sessionStorage.setItem("username", formData.username);
      navigate("/app/dashboard");
    } catch (error) {
      const message =
      error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : "Something went wrong. Please try again.";

  setNotification({ type: "error", message });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseNotification = () => setNotification(null);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white px-4">
      <div className="w-full max-w-sm p-6 rounded-lg shadow border border-[#dde1e3] bg-white">
        <h2 className="text-2xl font-bold mb-6 text-center">Login</h2>

        {notification && (
          <div
            className={`mb-4 px-4 py-3 rounded flex justify-between items-start ${
              notification.type === "error"
                ? "bg-red-100 text-red-700"
                : "bg-green-100 text-green-700"
            }`}
          >
            <span>{notification.message}</span>
            <button
              onClick={handleCloseNotification}
              className="ml-4 font-bold text-lg leading-none"
            >
              ×
            </button>
          </div>
        )}

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <label className="block mb-1 font-medium text-[#111518]">
              Username <span className="text-red-500">*</span>
            </label>
            <input
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="User Name"
              className="w-full rounded-lg border border-[#dce1e5] bg-white h-12 px-4 text-base text-[#111518] placeholder:text-[#637988] focus:outline-none focus:border-[#1993e5]"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium text-[#111518]">
              Password <span className="text-red-500">*</span>
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Password"
              className="w-full rounded-lg border border-[#dce1e5] bg-white h-12 px-4 text-base text-[#111518] placeholder:text-[#637988] focus:outline-none focus:border-[#1993e5]"
            />
          </div>

          {/* <button
            type="submit"
            className="bg-black text-white py-3 hover:bg-[#dce1e5] hover:text-black rounded-full font-bold"
          >
            Login
          </button> */}
          <button
          type="submit"
            className="bg-black text-white py-3 hover:bg-[#dce1e5] hover:text-black rounded-full font-bold"
        >
          {
            isLoading ?
              <div className="flex justify-center"><Spinner animation="border" size="sm" style={{ width: '1rem', height: '1rem' }} />Loging In...</div>
              :
              'Login'
          }

        </button>
        </form>

        <div className="mt-4 text-center">
          <Link
            to="/forgot-password"
            className="text-sm text-[#1993e5] hover:underline"
          >
            Forgot Password?
          </Link>
        </div>
      </div>
    </div>
  );
}
